export function flattenObject(obj: any, prefix = ''): Record<string, any> {
  const out: Record<string, any> = {};
  if (obj == null || typeof obj !== 'object') return out;

  for (const [k, v] of Object.entries(obj)) {
    const key = prefix ? `${prefix}.${k}` : k;
    if (v && typeof v === 'object' && !Array.isArray(v) && !(v instanceof Date)) {
      Object.assign(out, flattenObject(v, key));
    } else {
      out[key] = v;
    }
  }
  return out;
}

export function uniqueKeysFromRows(rows: any[], flatten: boolean): string[] {
  const keys = new Set<string>();
  for (const r of rows ?? []) {
    if (r == null) continue;
    if (flatten) {
      Object.keys(flattenObject(r)).forEach(k => keys.add(k));
    } else {
      Object.keys(r).forEach(k => keys.add(k));
    }
  }
  return Array.from(keys);
}

/** safe getter for dot paths like "review.appointmentDate" */
export function getByPath(obj: any, path: string) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc, p) => (acc == null ? undefined : acc[p]), obj);
}

/** pretty up values for export */
export function normalizeForExport(value: any) {
  if (value == null) return '';
  if (value instanceof Date) return value.toISOString();
  if (Array.isArray(value)) return JSON.stringify(value);
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return value;
}
